import type { JDSDatepickerMobileInternalProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSDatepickerMobileInternalProps>
  ): React.FC<JDSDatepickerMobileInternalProps> =>
  (props: JDSDatepickerMobileInternalProps) => {
    return <Component {...props} />;
  };
